export enum ConfigActionTypes {
  GET_UNI_CONFIG = '@@visa/GET_UNI_CONFIG',
  SET_UNI_CONFIG_LOADED = '@@visa/SET_UNI_CONFIG_LOADED',
  SET_STUDENT_CONFIG_LOADED = '@@visa/SET_STUDENT_CONFIG_LOADED',
  GET_UNI_CONFIG_SUCCESS = '@@visa/GET_UNI_CONFIG_SUCCESS',
  GET_UNI_CONFIG_FAILURE = '@@visa/GET_UNI_CONFIG_FAILURE',
  REFRESH_UNI_CONFIG = '@@visa/REFRESH_UNI_CONFIG',
  GET_UNI_CONFIG_BY_STUDENT_ID = '@@visa/GET_UNI_CONFIG_BY_STUDENT_ID',
  GET_UNI_CONFIG_BY_STUDENT_ID_SUCCESS = '@@visa/GET_UNI_CONFIG_BY_STUDENT_ID_SUCCESS',
  GET_UNI_CONFIG_BY_STUDENT_ID_FAILURE = '@@visa/GET_UNI_CONFIG_BY_STUDENT_ID_FAILURE',
  SAVE_CONFIG = '@@visa/SAVE_CONFIG',
  SAVE_CONFIG_SUCCESS = '@@visa/SAVE_CONFIG_SUCCESS',
  SAVE_CONFIG_FAILURE = '@@visa/SAVE_CONFIG_FAILURE',
  IMPORT_SSH_PUB_KEY = '@@visa/IMPORT_SSH_PUB_KEY',
  IMPORT_SSH_PUB_KEY_SUCCESS = '@@visa/IMPORT_SSH_PUB_KEY_SUCCESS',
  IMPORT_SSH_PUB_KEY_FAILURE = '@@visa/IMPORT_SSH_PUB_KEY_FAILURE',
  SAVE_CALENDLY_CONFIG = '@@visa/SAVE_CALENDLY_CONFIG',
  SAVE_CALENDLY_CONFIG_SUCCESS = '@@visa/SAVE_CALENDLY_CONFIG_SUCCESS',
  SAVE_CALENDLY_CONFIG_FAILURE = '@@visa/SAVE_CALENDLY_CONFIG_FAILURE',
  GET_UNI_REGION_INTERVIEW_CONFIG = '@@region-interview-config/GET_UNI_REGION_INTERVIEW_CONFIG',
  GET_UNI_REGION_INTERVIEW_CONFIG_SUCCESS = '@@region-interview-config/GET_UNI_REGION_INTERVIEW_CONFIG_SUCCESS',
  GET_UNI_REGION_INTERVIEW_CONFIG_FAILURE = '@@region-interview-config/GET_UNI_REGION_INTERVIEW_CONFIG_FAILURE',
  GET_PARTNER_CONFIG_BY_NAME = '@@sys-config/GET_PARTNER_CONFIG_BY_NAME',
  GET_PARTNER_CONFIG_BY_NAME_SUCCESS = '@@sys-config/GET_PARTNER_CONFIG_BY_NAME_SUCCESS',
  GET_PARTNER_CONFIG_BY_NAME_FAILURE = '@@sys-config/GET_PARTNER_CONFIG_BY_NAME_FAILURE',
  GET_NAVIGATION_URLS = '@@config/GET_NAVIGATION_URLS',
  GET_NAVIGATION_URLS_SUCCESS = '@@config/GET_NAVIGATION_URLS_SUCCESS',
  GET_NAVIGATION_URLS_FAILURE = '@@config/GET_NAVIGATION_URLS_FAILURE',
  GET_FEATURE_FLAGS_DATA = '@@config/GET_FEATURE_FLAGS_DATA',
  GET_FEATURE_FLAGS_DATA_SUCCESS = '@@config/GET_FEATURE_FLAGS_DATA_SUCCESS',
  GET_FEATURE_FLAGS_DATA_FAILURE = '@@config/GET_FEATURE_FLAGS_DATA_FAILURE',
  GET_ADM_ALLOWED_ALIASES = '@@config/GET_ADM_ALLOWED_ALIASES',
  GET_ADM_ALLOWED_ALIASES_SUCCESS = '@@config/GET_ADM_ALLOWED_ALIASES_SUCCESS',
  GET_ADM_ALLOWED_ALIASES_FAILURE = '@@config/GET_ADM_ALLOWED_ALIASES_FAILURE',
}
